export default __webpack_public_path__ + "static/media/overviewBannerMobile.66e27c5b.jpg";